const PENDING_OP_KEY = "trekkin.pendingOp";

function nowTs() {
  return Date.now();
}

function safeRead() {
  if (typeof window === "undefined" || !window.localStorage) return null;
  try {
    const raw = window.localStorage.getItem(PENDING_OP_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

function safeWrite(payload) {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.setItem(PENDING_OP_KEY, JSON.stringify(payload));
  } catch {}
}

export function getPendingOp() {
  return safeRead();
}

export function startPendingOp(type, meta = {}) {
  const opId = `${String(type || "op")}_${nowTs()}_${Math.random().toString(36).slice(2, 8)}`;
  const payload = {
    opId,
    type: String(type || "unknown"),
    stage: "start",
    startedAt: nowTs(),
    updatedAt: nowTs(),
    meta: meta && typeof meta === "object" ? meta : {},
  };
  safeWrite(payload);
  return opId;
}

export function updatePendingOp(opId, stage, extra = {}) {
  const current = safeRead();
  if (!current || current.opId !== opId) return;
  safeWrite({
    ...current,
    stage: String(stage || "update"),
    updatedAt: nowTs(),
    extra: extra && typeof extra === "object" ? extra : {},
  });
}

export function finishPendingOp(opId, result = "ok", extra = {}) {
  const current = safeRead();
  if (!current || current.opId !== opId) return;
  safeWrite({
    ...current,
    stage: String(result || "done"),
    finishedAt: nowTs(),
    updatedAt: nowTs(),
    extra: extra && typeof extra === "object" ? extra : {},
  });
  try {
    window.localStorage.removeItem(PENDING_OP_KEY);
  } catch {}
}

